/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  document.addEventListener('DOMContentLoaded', function() {
    // Function to update the color label when swatch selection changes
    function updateColorLabel() {
      // Get all swatch inputs
      const swatchInputs = document.querySelectorAll('.swatch__input');
      const colorLabelElement = document.querySelector('.radio__legend__label .selected-color-value');
      
      if (!colorLabelElement) return;
      
      // Find the currently selected swatch
      let selectedColorValue = '';
      swatchInputs.forEach(input => {
        if (input.checked) {
          selectedColorValue = input.value;
        }
      });
      
      // Update the label with the selected color
      colorLabelElement.textContent = selectedColorValue;
    }
    
    // Run once on page load to set initial value
    updateColorLabel();
    
    // Add event listeners to all swatch inputs
    document.querySelectorAll('.swatch__input').forEach(input => {
      input.addEventListener('change', updateColorLabel);
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
